import { render, staticRenderFns } from "./OrdemServico.vue?vue&type=template&id=5a8db172&scoped=true&"
import script from "./OrdemServico.vue?vue&type=script&lang=js&"
export * from "./OrdemServico.vue?vue&type=script&lang=js&"
import style0 from "./OrdemServico.vue?vue&type=style&index=0&id=5a8db172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8db172",
  null
  
)

export default component.exports